import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        
        {/* 1. SÜTUN: Logo ve Firma Özeti */}
        <div className="footer-col brand-col">
          
          {/* LOGO: Arkası şeffaf, zarif aydınlatmalı */}
          <img src="/logo.png" alt="Ankara Merkez Teknik Logo" className="footer-logo-transparent" />
          
          <p className="footer-desc">
            Ankara'nın 7/24 kesintisiz, garantili ve en güvenilir kombi, klima ve beyaz eşya teknik servis sağlayıcısı. Profesyonel kadro, orijinal yedek parça.
          </p>
          
          {/* YENİ TASARIM: MODERN VE TIKLANABİLİR SOSYAL MEDYA İKONLARI */}
          <div className="social-icon-group">
            {/* INSTAGRAM BUTONU */}
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-btn ig-btn" title="Instagram'da Bizi Takip Edin">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            
            {/* WHATSAPP BUTONU (Direkt sohbete atar) */}
            <a href="https://wa.me/903125810881" target="_blank" rel="noopener noreferrer" className="social-btn wp-btn" title="WhatsApp'tan Yazın">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.305-.885-.653-1.48-1.46-1.653-1.758-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* 2. SÜTUN: Hızlı Linkler */}
        <div className="footer-col">
          <h4>Hızlı Menü</h4>
          <ul className="footer-links">
            <li><Link to="/">Ana Sayfa</Link></li>
            <li><Link to="/hakkimizda">Hakkımızda</Link></li>
            <li><Link to="/hizmetler">Hizmetlerimiz</Link></li>
            <li><Link to="/iletisim">İletişim</Link></li>
          </ul>
        </div>

        {/* 3. SÜTUN: Popüler Hizmetler (SEO Odaklı İç Linkler) */}
        <div className="footer-col">
          <h4>Hizmetlerimiz</h4>
          <ul className="footer-links">
            <li><Link to="/hizmet/kombi-servisi">Kombi Teknik Servis</Link></li>
            <li><Link to="/hizmet/klima-servisi">Klima Teknik Servis</Link></li>
            <li><Link to="/hizmet/camasir-makinesi-servisi">Çamaşır Makinesi Teknik Servis</Link></li>
            <li><Link to="/hizmet/bulasik-makinesi-servisi">Bulaşık Makinesi Teknik Servis</Link></li>
            <li><Link to="/hizmet/buzdolabi-servisi">Buzdolabı Teknik Servis</Link></li>
          </ul>
        </div>

        {/* 4. SÜTUN: İletişim Bilgileri */}
        <div className="footer-col contact-col">
          <h4>İletişim</h4>
          <ul className="footer-contact-info">
            <li>📞 <strong>Telefon:</strong> <a href="tel:03125810881">0312 581 08 81</a></li>
            <li>📧 <strong>E-Posta:</strong> info@ankaramerkezteknik.com</li>
            <li>🕒 <strong>Mesai:</strong> 7/24 Servis</li>
          </ul>
        </div>

      </div>

      {/* EN ALT BİLGİ ŞERİDİ */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Ankara Merkez Teknik. Tüm Hakları Saklıdır.</p>
      </div>
    </footer>
  );
}

export default Footer;